"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
const bootstrap_1 = require("./utils/bootstrap");
function init(config, variant) {
    if (!variant && window._tblGravity?.variantName) {
        variant = window._tblGravity.variantName;
    }
    const module = (0, bootstrap_1.getModule)(config, variant);
    window._tblGravity.module = module;
    window._tblGravity.tblSLLinksAndButtonsInit = async () => {
        await module.execute();
    };
    window._tblGravity.reInitialize = (variant) => {
        init(config, variant);
    };
}
exports.init = init;
window._tblGravity = window._tblGravity || {};
window._tblGravity.init = init;
